import { render, staticRenderFns } from "./StaffHours.vue?vue&type=template&id=4032144c&"
import script from "./StaffHours.vue?vue&type=script&lang=js&"
export * from "./StaffHours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports